import { combineReducers } from "redux";
import { controllersState } from "./controllersReducer";

export const controllersReducers = combineReducers({
    controllersState: controllersState
});
